import Alide from './src/main'
import { addComponent } from '~/utils/helper'

export default addComponent(Alide)


// WEBPACK FOOTER //
// ./public/slide/index.js